import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/PersonaSeleccionesDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'personas/' + idPadre + '/selecciones/' + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('personas/' + idPadre + '/selecciones/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista('personas/' + idPadre + '/selecciones');
};

export const PostItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'personas/' + idPadre + '/selecciones',
    DTOs.saveItem(datosItem)
  );
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'personas/' + idPadre + '/selecciones/' + datosItem.id,
    DTOs.saveItem(datosItem)
  );
};
